'use client'

import { Paper, Typography } from '@mui/material'
import React from 'react'
import { useTranslations } from 'next-intl'

const NoFareRules: React.FC = () => {
    const t = useTranslations('srpFlightDetails')

    return (
        <Paper
            sx={{
                p: 2,
                mt: 2,
                borderRadius: 2,
                backgroundColor: '#F9FAFB',
                textAlign: 'start',
                boxShadow: 'none'
            }}
        >
            <Typography>{t('noFareRulesAvailable')}</Typography>
        </Paper>
    )
}

export default NoFareRules